import { defineComponent as _defineComponent } from 'vue'
import LinkWithArrow from './LinkWithArrow.vue'
import BaseImage from '~/components/new/ui/BaseImage.vue'
import NoAvatar from '~/assets/img/news/no-image.svg'
import Location from '~/components/icons/Location.vue'
import type { Artist } from '~/types/Artist'

export type ArtistCardProps = {
  item: Artist;
  smallArtistCard?: boolean;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'ArtistCard',
  props: {
    item: null,
    smallArtistCard: { type: Boolean, default: false }
  },
  setup(__props: any) {

const apiEndpoint = process.env.API_ENDPOINT



return { __sfc: true,apiEndpoint, LinkWithArrow, BaseImage, NoAvatar, Location }
}

})